export default {
  path: '/financialAudit',
  name: 'financialAudit',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '财务审核',
    // keepAlive: false
  },
  children: [
    {
      // 财务审核-提现审核
      path: 'cashOutAuditIndex',
      name: 'cashOutAuditIndex',
      component: () => import('../../views/FinancialAudit/CashOutAudit/CashOutAuditIndex'),
      meta: { title: '提现审核', keepAlive: false }
    },
    {
      // 财务审核-提现审核-历史审核
      path: 'historyAudit',
      name: 'historyAudit',
      hidden: true,
      component: () => import('../../views/FinancialAudit/CashOutAudit/HistoryAudit'),
      meta: { title: '历史审核', keepAlive: false }
    },
    {
      // 财务审核-临时密码
      path: 'temporaryPassword',
      name: 'temporaryPassword',
      hidden: true,
      component: () => import('../../views/FinancialAudit/CashOutAudit/TemporaryPassword'),
      meta: { title: '临时密码', keepAlive: false }
    }
  ]
}